import { gql } from '@apollo/client'
import type { UseMutationProps } from '@ztechapps/common.hook'
import { useMutation } from '@ztechapps/common.hook'

export const buildUpdateCustomerCompanyNameQuery = (fragment?: string) => {
  fragment =
    fragment ??
    `
   _id
    company {
      _id
      name
    }
  `

  return gql(`
  mutation updateCustomerCompanyName($input: JSON!) {
    updateCustomerCompanyName(input: $input) {
       _id
       ${fragment}
    }
  }
`)
}

export const useUpdateCustomerCompanyName = ({ query, ...args }: UseMutationProps) => {
  query = query ?? buildUpdateCustomerCompanyNameQuery()

  return useMutation({ query, ...args })
}
